<ion-app>
  @if (hasLoginError()) {
    <lyceo-auth-error />
  } @else if (hasPersonIdError()) {
    <homi-person-id-error />
  } @else if (showLoader()) {
    <lyceo-loader imageSrc="/assets/icon/logo-blue.svg" />
  }

  <ion-router-outlet [animated]="this.platformString !== 'web'" />
</ion-app>
